import React from 'react';
import { Modal } from 'antd';
import { useDispatch, useSelector } from 'react-redux';

import { Button } from 'components/common';

import { toggleModal } from 'data/actions/modals';
import { resumeSequences } from 'data/actions/sequences';
import { modalsSelector, modalOptionsSelector } from 'data/selectors/modals';
import { Container } from '../deleteStep/styles';
import { ModalTitle, CloseIcon, Footer } from '../baseModal/styles';

const ResumeSequencesModal = () => {
  const dispatch = useDispatch();
  const { visible } = useSelector(modalsSelector);
  const { sequenceIds, setSelectedRowKeys } = useSelector(modalOptionsSelector);

  const handleClose = () => dispatch(toggleModal('resume_sequences', false));
  const handleResume = () => {
    dispatch(resumeSequences(sequenceIds));
    if (setSelectedRowKeys) setSelectedRowKeys([]);
    handleClose();
  };

  return (
    <Modal
      visible={visible}
      title={
        <ModalTitle>
          Resume {sequenceIds.length === 1 ? 'sequence' : 'sequences'}
          <CloseIcon onClick={handleClose} className="ic_close" />
        </ModalTitle>
      }
      closable={false}
      width={500}
      footer={false}
      onCancel={handleClose}
    >
      <Container>
        <div>
          You&#39;re about to resume the
          {sequenceIds.length === 1 ? 'sequence' : 'sequences'}.
        </div>
      </Container>
      <Footer>
        <Button data-form="true" type="primary" size="large" onClick={handleResume}>
          Resume
        </Button>
        <Button size="large" type="normal" onClick={handleClose}>
          No
        </Button>
      </Footer>
    </Modal>
  );
};

export default ResumeSequencesModal;
